import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'course-authoring.course-team.add-team-member.title',
    defaultMessage: 'Add team members to this course',
  },
  description: {
    id: 'course-authoring.course-team.add-team-member.description',
    defaultMessage: 'Adding team members makes course authoring collaborative. Users must be signed up for Studio and have an active account.',
  },
  button: {
    id: 'course-authoring.course-team.add-team-member.button',
    defaultMessage: 'Add a new team member',
  },
});

export default messages;
